// Library imports
import styled from 'styled-components';
import { MDBContainer, MDBRow } from 'mdb-react-ui-kit';
// Util imports
import { LARGE_SCREEN_WIDTH } from '../../utils/constants';

export const SearchFilterContainer = styled(MDBContainer)`
    display: flex;
    justify-content: center;
    background: rgba(8,11,18,0.88);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    padding: 0.7rem 0px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    @media (max-width: ${LARGE_SCREEN_WIDTH}) {
        justify-content: flex-start;
        padding: 0.5rem 0px;
    }

    /* ── Dark overrides for all MDB dropdown buttons and menus inside ── */
    .btn {
        background: transparent !important;
        color: #94a3b8 !important;
        box-shadow: none !important;
        border-color: transparent !important;
    }
    .btn:hover, .btn:focus, .btn:active, .btn.active {
        background: rgba(255,255,255,0.07) !important;
        color: #e2e8f0 !important;
        box-shadow: none !important;
    }
    .btn span, .btn div, .btn i {
        color: inherit !important;
    }
    .dropdown-menu {
        background: #111827 !important;
        border: 1px solid rgba(255,255,255,0.1) !important;
        box-shadow: 0 20px 60px rgba(0,0,0,0.6) !important;
    }
    .dropdown-item {
        color: #cbd5e1 !important;
        background: transparent !important;
        border-bottom-color: rgba(255,255,255,0.07) !important;
    }
    .dropdown-item:hover, .dropdown-item:focus {
        background: rgba(59,130,246,0.12) !important;
        color: #e2e8f0 !important;
    }
    .dropdown-item.active {
        background: #3b82f6 !important;
        color: #ffffff !important;
    }
`;

export const SearchFilterRow = styled(MDBRow)`
    width: 90%;
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 999px;
    align-items: stretch;
    background: rgba(255,255,255,0.04);

    .first-col .dropdown {
        border-right: 1px solid rgba(255,255,255,0.1);
    }
    .last-col .dropdown {
        border-left: 1px solid rgba(255,255,255,0.1);
    }
    .dropdown {
        height: 100%;
    }

    @media (max-width: ${LARGE_SCREEN_WIDTH}) {
        border: 0px;
        padding-left: 2rem;
        flex-direction: column;
        background: transparent;
        .dropdown {
            border-left: 0px !important;
            border-right: 0px !important;
        }
        button {
            border-radius: 0px !important;
        }
        .search-col {
            order: 1;
        }
        .first-col {
            order: 2;
            margin-top: 0.75rem;
        }
        .last-col {
            order: 3;
            margin-top: 0.25rem;
        }

        .last-col .dropdown {
            border: 1px solid rgba(255,255,255,0.12) !important;
        }
    }
`;

export const SearchWrapper = styled.div`
    background: transparent;
    height: 100%;

    /* Kill every MDB notch/outline element that adds white borders or shadows */
    & .form-outline,
    & input,
    & .form-notch-trailing,
    & .form-notch-leading,
    & .form-notch-middle {
        height: 100%;
        border-radius: 0px !important;
        border: 0px !important;
        box-shadow: none !important;
        background: transparent !important;
        color: #e2e8f0 !important;
    }

    /* Remove MDB's focus ring / outer glow */
    & .form-outline:focus-within,
    & .form-outline.focused,
    & input:focus {
        box-shadow: none !important;
        outline: none !important;
    }

    /* Notch elements produce a white "border" frame — hide completely */
    & .form-notch-leading,
    & .form-notch-middle,
    & .form-notch-trailing {
        display: none !important;
    }

    & input {
        color: #e2e8f0 !important;
        caret-color: #60a5fa;
        padding-top: 0.72rem !important;
        padding-bottom: 0.72rem !important;
    }

    & input::placeholder {
        opacity: 1 !important;
        color: #4b5563 !important;
    }

    & label {
        color: #4b5563 !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        transition: none !important;
    }

    & .form-outline.active label,
    & input:focus + label,
    & input:not(:placeholder-shown) + label {
        display: none !important;
    }

    @media (max-width: ${LARGE_SCREEN_WIDTH}) {
        & input {
            padding: 1rem !important;
        }
    }
`;

// ─── Outer bar – dark themed ─────────────────────────────────────────────
// ─── Pill-shaped controls row ─────────────────────────────────────────────
// ─── Search input ─────────────────────────────────────────────────────────
// ─── Select dropdown ──────────────────────────────────────────────────────
// ─── Sort/filter icon label ───────────────────────────────────────────────
